import React from 'react'
import CategoryFilter from './category/CategoryFilter'
import ViewFilter from './view/ViewFilter'

import '../../styles/scss/components/filters/event-filters.scss'

const EventsFilters = () => {
  return (
    <div className="flow-events__filters">
      <div className="flow-events__filters-container">
        <CategoryFilter />
        <ViewFilter />
      </div>
    </div>
  )
}

export default EventsFilters
